"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getOptions;
var _axios = _interopRequireDefault(require("axios"));
var _settings = require("../settings");
var _GetOptionsError = _interopRequireDefault(require("../customErrors/GetOptionsError"));
function buildGetOptionsParameters(productId, configurationId, externalProductId, partnerProductId) {
  if (configurationId) {
    return {
      productId: productId,
      configurationIdForSelections: configurationId
    };
  }
  if (externalProductId) {
    return {
      productId: productId,
      externalProductId: externalProductId
    };
  }
  if (partnerProductId) {
    return {
      productId: productId,
      partnerProductId: partnerProductId
    };
  }
  return {
    productId: productId
  };
}
function getOptions() {
  var _getSettings = (0, _settings.getSettings)(),
    getOptionsApi = _getSettings.getOptionsApi,
    productId = _getSettings.productId,
    configurationId = _getSettings.configurationId,
    externalProductId = _getSettings.externalProductId,
    partnerProductId = _getSettings.partnerProductId;
  if (typeof getOptionsApi === 'string') {
    return (0, _axios["default"])({
      url: getOptionsApi,
      params: buildGetOptionsParameters(productId, configurationId, externalProductId, partnerProductId),
      method: 'GET',
      crossDomain: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response;
    })["catch"](function (error) {
      console.error(error); // eslint-disable-line no-console
      throw new _GetOptionsError["default"](error);
    });
  } else if (typeof getOptionsApi === 'function') {
    return getOptionsApi(productId, configurationId, externalProductId, partnerProductId);
  }
  return Promise.resolve({
    status: 200
  });
}
//# sourceMappingURL=optionsApi.js.map